import MonitoringQueueEntrySearchDetailsTableRow from './MonitoringQueueEntrySearchDetailsTableRow';

export default MonitoringQueueEntrySearchDetailsTableRow;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-details-form/table/row/index.js